import axios from './axios';

/**
 * @api get /sos/count Count not closed SOS alarms.
 *
 * @return {Promise}
 * */
export const getActiveAlarmsCount = () => axios.get('/sos/count');

/**
 * @api post /sos/search Search not closed SOS alarms.
 *
 * @param {object} params
 *
 * @return {Promise}
 */
export const getActiveAlarms = params => axios.post('/sos/search', params);

/**
 * @api post /sos/history/search Search Closes SOS Alarms History.
 *
 * @param {object} pagination
 * @param {array|null} filters
 *
 * @return {Promise}
 */
export const getAlarmsHistory = query => axios.post('/sos/history/search', query);

/**
 * @api post /sos/history/{alarmId} Get Closed SOS Alarm History.
 *
 * @param {string} alarmId
 *
 * @return {Promise}
 */
export const getAlarmHistoryDetails = alarmId => axios.get(`/sos/history/${alarmId}`);

/**
 * @api get /sos/{alarmId}/comments Search SOS alarm comments.
 *
 * @param {string} alarmId
 *
 * @return {Promise}
 */
export const getAlarmMessages = alarmId => axios.get(`/sos/${alarmId}/comments`);

/**
 * @api put /sos/{alarmId} Update SOS alarm.
 *
 * @param {string} alarmId
 * @param {string} body
 * @param {boolean} close
 *
 * @return {Promise}
 */
export const sendAlarmMessage = (alarmId, body, close) =>
  axios.put(`/sos/${alarmId}`, {
    body,
    close,
  });

/**
 * @api post /sos/{alarmId}/call Start call with alarm initiator.
 *
 * @param {string} alarmId
 *
 * @return {Promise}
 */
export const startAlarmCall = alarmId => axios.post(`/sos/${alarmId}/call`);

/**
 * @api put /sos/{alarmId}/call Stop call with alarm initiator.
 *
 * @param {string} alarmId
 *
 * @return {Promise}
 */
export const stopAlarmCall = alarmId => axios.delete(`/sos/${alarmId}/call`);

/**
 * @api post /emergency/calls/history/search Search emergency calls history.
 *
 * @param {object} query
 *
 * @return {Promise}
 */
export const searchCallsHistory = query => axios.post('/emergency/calls/history/search', query);
